import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import mint from '@tunein/mint';
import { toggleMuteVolume } from 'src/common/actions/player';

class UnlockAdSlot extends Component {
  static propTypes = {
    unlockActions: PropTypes.shape({
      unlockSuccess: PropTypes.func.isRequired,
      unlockFailure: PropTypes.func.isRequired,
      unlockCredit: PropTypes.func.isRequired,
    }),
    campaignId: PropTypes.number,
    campaignKey: PropTypes.string,
    unlockToken: PropTypes.string,
    volume: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
    playerActions: PropTypes.object.isRequired,
    style: PropTypes.object,
    callbackHandler: PropTypes.object,
    isCreditUnlocked: PropTypes.bool.isRequired,
    unlockFailed: PropTypes.bool,
    unlockFailedError: PropTypes.string,
  };

  state = {
    waitingToUnmute: false,
  };

  componentDidMount() {
    const { unlockActions, campaignId, campaignKey, unlockToken, id } =
      this.props;

    mint.requestPremiumUnlockActivity({
      slotName: 'premium_unlock',
      elementId: id,
      campaignId,
      campaignKey,
      unlockToken,
      // callbackHandler is an empty object that is assigned a
      // closeCallback method in mint's truexNetworkController.serveAd()
      callbackHandler: this.props.callbackHandler,
      onStart: (width, height) => {
        this.handleMute();
        unlockActions.updateUnlockDialogDimensions(width, height);
      },
      onCredit: (params) => {
        unlockActions.unlockCredit(params);
      },
      onFinish: () => {
        this.handleUnmute();
        unlockActions.unlockSuccess();
      },
      onError: () => {
        this.handleUnmute();
        unlockActions.unlockFailure();
      },
    });
  }

  componentDidUpdate(prevProps) {
    const { unlockFailed, unlockFailedError, callbackHandler } = this.props;

    if (!prevProps.unlockFailed && unlockFailed) {
      callbackHandler.handleError(unlockFailedError);
    }
  }

  componentWillUnmount() {
    const { callbackHandler, isCreditUnlocked, unlockFailed } = this.props;

    this.handleUnmute();

    if (unlockFailed) {
      return;
    }

    if (callbackHandler.closeCallback) {
      callbackHandler.closeCallback(isCreditUnlocked);
    }
  }

  handleMute() {
    if (this.props.volume > 0) {
      this.props.playerActions.toggleMuteVolume();
      this.setState({ waitingToUnmute: true });
    }
  }

  handleUnmute() {
    if (this.state.waitingToUnmute) {
      this.props.playerActions.toggleMuteVolume();
      this.setState({ waitingToUnmute: false });
    }
  }

  render() {
    const { style, id } = this.props;
    return (
      <div style={style}>
        <div id={id} />
      </div>
    );
  }
}

UnlockAdSlot.defaultProps = {
  callbackHandler: {},
};

function mapStateToProps({ player, unlockDetails }) {
  const { isCreditUnlocked, unlockFailed, unlockFailedError } = unlockDetails;
  return {
    volume: player.volume,
    isCreditUnlocked,
    unlockFailed,
    unlockFailedError,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    playerActions: bindActionCreators(
      {
        toggleMuteVolume,
      },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UnlockAdSlot);
